import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactNode } from 'react';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import { useLookupResultRefundData } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

interface Props {
  isVIP: boolean;
  children: ReactNode;
}

export const ResultPageLayout = ({ isVIP, children }: Props) => {
  const { businessType } = useLookupResultRefundData();
  const pageName = businessType === 'corps' ? 'corps-lookup' : 'indis-lookup';
  const inquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.default, `${pageName}_cx_top-right`);

  return (
    <PageViewEventLogger pageName={pageName}>
      <Layout
        leftIcon={{
          icon: 'back',
          clickEvent: { name: `${pageName}_topnav_back` }
        }}
        rightTextButton={!isVIP ? inquiryButton : undefined}
        className={'lookup-result-layout'}
        mainClassName={'flex !w-full flex-col !items-center !max-w-none !m-0'}
      >
        {children}
      </Layout>
    </PageViewEventLogger>
  );
};
